import store from "@/store";
import Keycloak from "keycloak-js";
import UserInfo from "@/classes/global/UserInfo";

import router from "@/router";
import API from "@/classes/global/API";

let url = new URL(window.location.origin.toString()).hostname;
let owner = url.split('.')[0];

const routeGuardErrorPage = 'routeGuardErrorPage';

const kcConfiguration = {

    url: process.env.VUE_APP_KEYCLOAK_REALM,
    realm: owner,
    clientId: owner,
    onLoad: 'login-required'
}

const options = {
    redirectUri: window.location.href
}

const minTokenValidity = 15;

let keyCloak = new Keycloak(kcConfiguration);
let userInfo = new UserInfo();

export default {

    authenticate(app, axios) {

        // keyCloak.onAuthSuccess = () => this.getUserInfo(app, axios, store.state.loginDetails.sub);

        keyCloak.init({onLoad: 'login-required'}).then(async (authenticated) => {

            if (!authenticated) {
                window.location.reload();

            } else {

                store.state.loginDetails = keyCloak.idTokenParsed;

                userInfo.firstName = keyCloak.idTokenParsed.given_name;
                userInfo.lastName = keyCloak.idTokenParsed.family_name;
                userInfo.email = keyCloak.idTokenParsed.email;

                //Refresh the token just before the service call to the service layer if we only have 15 seconds left
                axios.interceptors.request.use(async (config) => {

                    await keyCloak.updateToken(minTokenValidity).then(function (refreshed) {

                        store.state.loginDetails = keyCloak.refreshTokenParsed;
                        config.headers.Authorization = "Bearer " + keyCloak.token;

                    }).catch(function () {

                        //Override the logout so that if the user logs back in they come to the same place
                        //that they were automatically get logged out then they come bato the same place

                        keyCloak.logout(options)

                    });

                    return config;

                }, function (error) {
                    // Do something with request error
                    return Promise.reject(error);
                });

                //Refresh the token just before we change views if we only have 15 seconds of validity left
                router.beforeResolve(async to => {

                    await keyCloak.updateToken(minTokenValidity)
                        .then(function (refreshed) {

                            store.state.loginDetails = keyCloak.refreshTokenParsed;

                        }).catch(function () {

                            keyCloak.logout(options)

                        });
                });

                //Refresh the token if the user refocuses on the tab views if we only have 15 seconds of validity left
                window.onfocus = async (event) => {

                    await keyCloak.updateToken(minTokenValidity)
                        .then(function (refreshed) {

                            store.state.loginDetails = keyCloak.refreshTokenParsed;

                        }).catch(function () {

                            keyCloak.logout(options)

                        });

                };

             this.getUserInfo(app, axios, store.state.loginDetails.sub);

            }

        }).catch((ex) => {
            //TODO: Add some logging here just incase we have some issues with keycloak - J.Clayton
            console.log(ex)
            console.log("Authenticated Failed");
        });
    },

    async getUserInfo(app, axios, userId) {

        try {

            // Prevent breaking the app if this fails with future browser updates
            store.state.caughtURL = new URL(window.location.href);

        } catch (error) {

            console.log(error)
        }

        await router.isReady();

        const to = router.currentRoute.value

            if(!store.state.userSettings.account) {
                getUserInformation(app, axios, userId, function() {

                    switch (to.name) {

                        case('dashboard'):
                            if (!store.state.mainMenu.dashboard)
                                router.push({ name: routeGuardErrorPage});
                            break;
                        case('showshipments'):
                            if (!store.state.mainMenu.shipmentItems.find(x => x.view === to.name).active)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('stock'):
                            if(!store.state.mainMenu.warehouseItems.find(x => x.view === to.name).active)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('purchaseorder'):
                            if(!store.state.mainMenu.orderItems.find(x => x.id === to.params.id).active)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('booking'):
                            if(!store.state.mainMenu.freightItems.find(x => x.section === to.params.section).active)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('quote'):
                            if(!store.state.mainMenu.quoteItems.find(x => x.id === to.params.id).active)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('documents'):
                            if(!store.state.mainMenu.documents)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('reports'):
                            if(!store.state.mainMenu.reports)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('skuhistory'): case('warehousejobs'): case('pickstock'):
                            if(!store.state.mainMenu.warehouseItems.find(x => x.view === to.name).active)
                                router.push({name: routeGuardErrorPage});
                            break;
                        case('prejob'):
                            if(!store.state.mainMenu.agentItems.find(x => x.section === to.params.section).active)
                                router.push({name: routeGuardErrorPage});
                            break;

                    }

                });
            }



    },

    logout() {

        keyCloak.logout({redirectUri: 'https://' + store.state.owner + '.boxtraxvision.com'});
    }

}

async function getUserInformation(app, axios, userId, callBack) {

    let response = await API.getUserInfoById(userId);

    if (response) {

        userInfo.userId = userId;
        userInfo.account = response.data.account.toLowerCase();
        userInfo.firstName = response.data.firstName;
        userInfo.lastName = response.data.lastName;

        userInfo.allowColumnMenuSearchShipments = response.data.allowColumnMenuSearchShipments;
        userInfo.searchShipmentColumns = response.data.searchShipmentColumns;
        userInfo.showCourierCustoms = response.data.showCourierCustoms;
        userInfo.showCourierTerms = response.data.showCourierTerms;
        userInfo.highlightActualDate = response.data.highlightActualDate;
        userInfo.showAirTrackingLink = response.data.showAirTrackingLink;
        userInfo.showSeaTrackingLink = response.data.showSeaTrackingLink;
        userInfo.useMeasuredGrid = response.data.useMeasuredGrid;
        userInfo.showShipmentsTabSettings = response.data.showShipmentsTabSettings;
        userInfo.showPickupDelivery = response.data.showPickupDelivery;
        userInfo.showStockValues = response.data.showStockValues;

        store.state.mainMenu = response.data.mainMenu;
        store.state.userSettings = userInfo;

        app.mount('#app');

        callBack();

    }

}
